// 创建ajax实例，拦截器请求器，拦截响应器，请求通用函数
import axios from 'axios'

// export const BASE_URL = 'http://0.0.0.0:8001'
export const BASE_URL = 'https://fastapi.frogplan.cn'
const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 5000
})

instance.interceptors.request.use((config) => {
  // 需要携带token
  return config
}, err => {
  return Promise.reject(err)
})

instance.interceptors.response.use((res) => {
  // token 失效的处理
  return res.data
}, err => {
  return Promise.reject(err)
})

// 导出请求通用函数
export default (url, method, submitData) => {
  return instance({
    url: BASE_URL + url,
    method: method,
    [method.toLowerCase() === 'get' ? 'params' : 'data']: submitData
  })
}
